import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M8 12.9q2.034-1.866 3.017-3.392Q12 7.984 12 6.8q0-1.817-1.158-2.975Q9.682 2.667 8 2.667q-1.684 0-2.842 1.158T4 6.8q0 1.184.983 2.708Q5.967 11.034 8 12.9m0 1.317q-.233 0-.467-.084a1.2 1.2 0 0 1-.416-.25 26 26 0 0 1-1.917-1.95 14.5 14.5 0 0 1-1.392-1.841 8.8 8.8 0 0 1-.85-1.717A4.7 4.7 0 0 1 2.667 6.8q0-2.5 1.608-3.983Q5.883 1.332 8 1.333q2.117 0 3.725 1.484T13.333 6.8q0 .75-.291 1.575a8.8 8.8 0 0 1-.85 1.717 14.5 14.5 0 0 1-1.392 1.841 26 26 0 0 1-1.917 1.95 1.2 1.2 0 0 1-.416.25 1.4 1.4 0 0 1-.467.084M8 8q.55 0 .942-.392.39-.391.391-.941 0-.55-.391-.942A1.28 1.28 0 0 0 8 5.333q-.55 0-.942.392a1.28 1.28 0 0 0-.391.942q0 .55.391.941Q7.45 8 8 8"
    }, null, -1)
  ]))]))
}
export default { render: render }